import { toneFromMarks } from "@-/com.npmjs.kensio__pinyinjs";

export type MorphemeTone = 0 | 1 | 2 | 3 | 4;

/** Extract tone (0-4) from either tone-number form (`ma3`) or diacritic form (`mǎ`); neutral → 0. */
export function toneForPinyin(pinyin: string): MorphemeTone | null {
  const trimmed = pinyin.trim();
  if (trimmed.length === 0) {
    return null;
  }
  const trailing = trimmed.codePointAt(trimmed.length - 1);
  // Accept a trailing tone digit `0`–`5`; both `0` and `5` denote the neutral tone (→ 0).
  if (trailing !== undefined && trailing >= 0x30 && trailing <= 0x35) {
    const digit = trailing - 0x30;
    switch (digit) {
      case 1:
      case 2:
      case 3:
      case 4: {
        return digit;
      }
      case 0:
      case 5: {
        return 0;
      }
      default: {
        break;
      }
    }
  }
  const tone = toneFromMarks(trimmed);
  return tone === undefined || tone === 5 ? 0 : tone;
}
